import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gender'
})
export class GenderPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    switch (value) {
      case 0:
        return 'للذكور فقط';
      case 1:
        return 'للإناث فقط';
      default:
        return 'أي جنس';
    }
  }

}

